import { createSelector } from '@reduxjs/toolkit';
import { TState } from 'store/types';
import { InviteOwnRespondentsSchema } from '../types/inviteOwnRespondentSchema';

export const getOwnRespondentInviteState = (
  state: TState,
): InviteOwnRespondentsSchema => state.ownRespondentInvite;

// OWN RESPONDENTS
export const getInviteHash = createSelector(
  getOwnRespondentInviteState,
  ({ actions: { invite_hash } }) => invite_hash,
);

export const getInviteCompanyName = createSelector(
  getOwnRespondentInviteState,
  ({ invite_company: { data } }) => data.company_name,
);

export const getInviteCompanyNameLoading = createSelector(
  getOwnRespondentInviteState,
  ({ invite_company: { loading } }) => loading,
);

export const getInviteCompanyNameError = createSelector(
  getOwnRespondentInviteState,
  ({ invite_company: { error } }) => error,
);

export const getInviteIsAccepted = createSelector(
  getOwnRespondentInviteState,
  ({ accept_invite: { isAccepted } }) => isAccepted,
);

export const getInviteAcceptError = createSelector(
  getOwnRespondentInviteState,
  ({ invite_company: { error: acceptError } }) => acceptError,
);

export const getInviteAcceptLoading = createSelector(
  getOwnRespondentInviteState,
  ({ invite_company: { loading: acceptLoading } }) => acceptLoading,
);
